export const breakpoints = {
  sm: '640px',   // small (móvil grande)
  md: '768px',   // medium (tablet)
  lg: '1024px',  // large (desktop)
  xl: '1280px',  // extra large
}
